import React from 'react';
import {
  useProvidedTranslations,
} from '../../context';
import LayoutNav from '../LayoutNav';
import Prestamos from './index';

const cfg = {
  i18nKey: 'dash.prestamos',
};

const PrestamosWithLayout = () => {
  const translations = useProvidedTranslations();

  return (
    <LayoutNav title={translations.formatMessage(`${cfg.i18nKey}.header`)}>
      <Prestamos />
    </LayoutNav>
  );
};

export default PrestamosWithLayout;
